import React from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { elfGreen, red } from 'Utils/styles/colors'

export type CategoryTaxability = boolean

interface CategoryTaxabilitySelectorProps {
  label: string
  value: CategoryTaxability
  onChange: (value: CategoryTaxability) => void
  name?: string
  disabled?: boolean
  required?: boolean
}

export const CategoryTaxabilitySelector: React.FC<CategoryTaxabilitySelectorProps> = ({
  label,
  value,
  onChange,
  name,
  disabled = false,
  required = false
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value === 'true')
  }

  const getValueColor = (taxable: CategoryTaxability): string => (taxable ? elfGreen : red)

  return (
    <FormControl disabled={disabled} required={required} sx={{ minWidth: 120 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        name={name}
        value={value.toString()}
        onChange={handleChange}
        label={label}
        sx={{
          '& .MuiSelect-select': {
            color: getValueColor(value)
          }
        }}
      >
        <MenuItem value="true" sx={{ color: getValueColor(true) }}>
          Taxable
        </MenuItem>
        <MenuItem value="false" sx={{ color: getValueColor(false) }}>
          Non-taxable
        </MenuItem>
      </Select>
    </FormControl>
  )
}

export const convertToBackendFormat = (
  categoryIds: number[],
  taxableSettings: Record<number, CategoryTaxability>
): Array<{ basic_benefit_program_category_id: number; taxable: boolean }> => {
  return categoryIds.map((id) => ({
    basic_benefit_program_category_id: id,
    taxable: taxableSettings[id] ?? true
  }))
}
